module.exports = "<div class=\"scroll-content\">\n  <div class=\"top\" (click)=\"scrollToTop()\"> </div>  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/scroll-top/scroll-top.component.html
// module id = ./src/app/scroll-top/scroll-top.component.html
// module chunks = main